<div class="order-details__list-item">
  <div class="detail-left-col">{{ 'FRONTEND.SALES_UI.NOTES' | translate }}</div>
  <div class="order-details__list-item__value">
    <div class="item_container">
      <ng-container *ngIf="isEditing; else display">
        <glxy-form-field class="notes-input" [bottomSpacing]="'none'">
          <textarea
            matInput
            name="notes"
            [value]="notes"
            [(ngModel)]="notes"
            placeholder="{{ 'FRONTEND.SALES_UI.NOTES' | translate }}"
          ></textarea>
          <glxy-hint>{{ 'FRONTEND.SALES_UI.NOTES_HINT' | translate }}</glxy-hint>
        </glxy-form-field>
        <button mat-flat-button color="primary" (click)="updateNotes()">
          <glxy-button-loading-indicator [isLoading]="updatingNotes">
            {{ 'FRONTEND.SALES_UI.SAVE' | translate }}
          </glxy-button-loading-indicator>
        </button>
      </ng-container>
    </div>
  </div>
</div>
<ng-template #display>
  <div class="show-line-breaks">{{ notes }}</div>
  <button *ngIf="editable" mat-icon-button class="order-details__notes-button" (click)="edit()">
    <mat-icon>edit</mat-icon>
  </button>
</ng-template>
<mat-divider></mat-divider>
